import React from 'react';
import axios from 'axios';
import saveAs from 'js-file-download';
import ContentDisposition from 'content-disposition';
import AuthStateContext from './AuthStateContext';

function createClient(getToken)
{
  return {
    get: async (path, token) => {
      var params;
      if (!token) {
        token = await getToken();
      }
      if (token) {
        params = {
          headers: {
              Authorization: `Bearer ${token}`
          }
        }
      }
      return axios.get(path, params);
    },

    post: async (path, request, token) => {
      var params = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      if (!token) {
        token = await getToken();
      }
      if (token) {
        params.headers.Authorization = `Bearer ${token}`;
      }
      return axios.post(path, JSON.stringify(request), params);
    },

    download: async (path, token) => {
      var params = {
        responseType: 'blob'
      };
      if (!token) {
        token = await getToken();
      }
      if (token) {
        params.headers = {
          Authorization: `Bearer ${token}`
        };
      }
      return axios.get(path, params)
        .then(response => {
          const contentDisposition = ContentDisposition.parse(response.headers['content-disposition']);
          saveAs(response.data, contentDisposition.parameters.filename);
        });
    }
  }
}

export default function useClient()
{
  const state = React.useContext(AuthStateContext);
  const getToken = React.useCallback(async () => {
    
    if (state.token) {
      return state.token;
    }
    else if (state.user) {
      return await state.user.getIdToken(/* forceRefresh */ true)
    }
    else {
      return null;
    }
  }, [state]);
 
  return React.useMemo(() => createClient(getToken), [getToken]);
}